export default class InstanceFilter {
  code: string;

  description: string;

  status: string;

  competence: string;

  constructor(obj: any) {
    this.code = obj.code || '';
    this.description = obj.description || '';
    this.status = obj.status || null;
    this.competence = obj.competence || null;
  }

  public static of(obj: any) {
    return new InstanceFilter(obj || {})
  }
}
